import * as actions from "appRedux/actions/addon/AddonActionType"

export interface AddonState {
  loader: boolean
  exportParams: {
    [key: string]: {
      data: any | null
      error: string | null
    }
  }
  process: {
    status: boolean
    action: string
    message: string
  }
}

const initialState: AddonState = {
  loader: false,
  exportParams: {},
  process: { status: false, action: "", message: "" }
}

export default (state: AddonState = initialState, action: actions.AddonAction): AddonState => {
  switch (action.type) {
    case actions.EXPORT_PARAMS_REQUEST: {
      return {
        ...state,
        loader: true,
        process: { status: false, action: "", message: "" }
      }
    }
    case actions.EXPORT_PARAMS_SUCCESS: {
      return {
        ...state,
        loader: false,
        exportParams: {
          ...state.exportParams,
          [action.payload.code]: {
            data: action.payload.data,
            error: null
          }
        },
        process: { status: true, action: "exportParams", message: "Success" }
      }
    }
    case actions.EXPORT_PARAMS_FAILURE: {
      return {
        ...state,
        loader: false,
        exportParams: {
          ...state.exportParams,
          [action.payload.code]: {
            data: null,
            error: action.payload.message
          }
        },
        process: { status: false, action: "exportParams", message: action.payload.message }
      }
    }
    case actions.EXPORT_PARAMS_RESET: {
      return {
        ...state,
        process: { status: false, action: "", message: "" }
      }
    }
    default:
      return state
  }
}

